import { HandySvg } from "handy-svg";
import Image from "next/image";
import styles from "./EraseInfo.module.scss";

const EraseInfo = ({ dictionary }) => {
	return (
		<section className={styles.container}>
			<h2 className={styles.title}>{dictionary["page_erase_header_remove"]}</h2>
			<p className={styles.description}>{dictionary["page_erase_description_remove"]}</p>
			<div className={styles.photo_wrapper}>
				<div className={styles.photo_before} data-title={dictionary["before"]}>
					<Image src={`/erase_and_replace/erase_info/image_before_erase.png`} alt={"Image before erase"} width="595" height="416" loading="lazy" />
					<HandySvg className={styles.arrow} src={"/erase_and_replace/erase_info/dotted_arrow.svg"} width={111} height={250} style={{ fill: "#6371DE" }} />
				</div>
				<div className={styles.photo_after} data-title={dictionary["after"]}>
					<Image src={`/erase_and_replace/erase_info/image_after_erase.png`} alt={"Image after erase"} width="595" height="416" loading="lazy" />
				</div>
			</div>
		</section>
	);
};

export default EraseInfo;
